export class OfferRequest {
    constructor(requesterName, requesterEmail, requesterPhone, requesterCity, requesterComment, models) {
        this.requesterName = requesterName;
        this.requesterEmail = requesterEmail;
        this.requesterPhone = requesterPhone;
        this.requesterCity = requesterCity;
        this.requesterComment = requesterComment;
        this.items = models;
    }
}
export class OfferRequestItem {
    constructor(shouldRotate, model, width, projection, freestanding, extras, left, right, close, far, frameColor, panelColor, insulatedPanel, modelImage) {
        this.shouldRotate = shouldRotate;
        this.model = model;
        this.width = width;
        this.projection = projection;
        this.freestanding = freestanding;
        this.extras = extras;
        this.left = left;
        this.right = right;
        this.close = close;
        this.far = far;
        this.frameColor = frameColor;
        this.panelColor = panelColor;
        this.insulatedPanel = insulatedPanel;
        this.modelImage = modelImage;
    }
}
